import { render, staticRenderFns } from "./SpontaneousSurveyForm.vue?vue&type=template&id=4c2079b2&"
import script from "./SpontaneousSurveyForm.vue?vue&type=script&lang=ts&"
export * from "./SpontaneousSurveyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports